<template>
  <div class="web-body">
    <div class="row    ">
      <h1 style="text-align:center;font-weight: bold;" class="col-md-12">WONDER GAMES’S STATEMENT OF PRIVACY
        PROTECTION</h1>
    </div>
    <div class="row">
      <h5 class="col-md-12">WONDER GAMES attaches great importance to protecting your privacy. Before using
        the services or apps provided by WONDER GAMES, please read carefully the following statements.
        please read carefully the following statements. In order to provide more accurate and well-targeted
        services, WONDER GAMES may use personal information submitted by you in the manners mentioned below;
        nevertheless, WONDER GAMES will treat such information with a high level duty of diligence. Without your
        permission, WONDER GAMES will not disclose such information or provide such information to any third party.
      </h5>
    </div>
    <div class="row">
      <h4 class="col-md-12">Protecting Your Privacy </h4>
    </div>
    <div class="row">
      <h5 class="col-md-12">
        It is WONDER GAMES’s principle to respect the privacy of the personal information of our users. WONDER GAMES
        will take reasonable measures to protect user’s personal information, without disclosing such information to
        any third party other than its Partners (without the consent of the user), unless such disclosure is (i)
        required by law, court order or competent government departments or (ii) agreed to by the user. Exceptions
        will be applied if the user selects to accept such disclosures during the registration process (where
        applicable), or is otherwise stipulated on the disclosure or use of a user’s personal information between the
        user and WONDER GAMES and its Partners. The user shall bear any risks that WONDER GAMES from any authorized
        disclosure of a user’s personal information. For the operation and improvement of WONDER GAMES’s technologies
        and services, WONDER GAMES may collect and use the non-personal information of its users, or provide such
        information to third parties, in order to provide better user experience and improve the quality of our
        services.
      </h5>
    </div>
    <div class="row">
      <h4 class="col-md-12">Collection of Information</h4>
    </div>
    <div class="row">
      <h5 class="col-md-12">WONDER GAMES may collect your personal information when you voluntarily opt to use our
        services, apps or
        provide us with your personal information. We may use your personal information to communicate with you, and
        may send certain mandatory service communications to you, such as notification, information on technical
        service issues, and security announcements. We may also occasionally send you product surveys or promotional
        mailings to inform you of other products or services available from WONDER GAMES and its affiliates. Your
        download, installation and use of the software shall be deemed to constitute consent to our use of your
        personal information.
        In addition, your download, installation and use of products/service from WONDER GAMES and its affiliates,
        shall be deemed that you have expressly provided your consent to WONDER GAMES for disclosure of personal
        information to WONDER GAMES’s partners and/or affiliates “Partners”).
        In the event you submit feedback to us via our email,  we may collect and use certain of personal information
        you provide to us, including your e-mail address, which we may use to operate and improve our website and
        product(s)] and deliver the service or carry out improvements you have requested. These uses may include
        providing you with more effective customer service; making the sites, products or services easier to use.
      </h5>
    </div>
  </div>


</template>

<script>
  export default {
    name: "privacy_en",
    components: {}
  }
</script>

<style scoped>
  ul {
    list-style: none;
    padding: 0;
    margin: 0%
  }

  ul li {
    padding-left: 20px;
    line-height: 25px;
  }

  h4, h5 {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/privacy_en.vue